import { trackUtil } from 'common/services/analytics.service';

interface IAnalyticsPayload {
  onLoad?: string;
  eVar0?: string;
  eVar9?: string;
  prop15: string;
  prop35: string;
  prop36: string;
  prop0: string;
  prop28: string;
  prop41: string;
  prop49: string;
  prop18: string;
}

let payLoad = {} as IAnalyticsPayload;

export const setPayLoad = ({ partyAccount: partyId, type: role, segment = 'Enterprise', email, orgName, productName }: any) => {
  payLoad = { prop15: email, prop35: orgName, prop36: partyId, prop0: 'b2b|enterprise|dedicated internet', prop28: role, prop49: segment, prop18: productName, prop41: 'KAM' };
};

export const fireAnalyitcsOnPageLoad = () => {
  const linkName = 'b2b|data|landing page|rate card';
  trackUtil?.({ ...payLoad, eVar0: linkName, onLoad: linkName });
};

export const fireAnalyitcsOnProductChange = (productName: string) => {
  const linkName = 'b2b|data|landing page|rate card|select product';
  trackUtil?.({ ...payLoad, eVar9: linkName, click: linkName, prop18: productName });
};

export const fireAnalyitcsOnDownload = (productName: string) => {
  const linkName = 'b2b|data|landing page|rate card|download rate card';
  trackUtil?.({ ...payLoad, eVar9: linkName, click: linkName, prop18: productName });
};

export const fireAnalyitcsOnSupport = (productName: string) => {
  const linkName = 'b2b|data|landing page|rate card|l1 support';
  trackUtil?.({ ...payLoad, eVar9: linkName, prop18: productName });
};
